import {
  type AxiosRequestConfig,
  type DefaultQueryError,
  httpClient,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { LocationFeature } from './types';
import { apiRoutes } from '@/api/api-routes';

export const locationFeaturesFn = async (config: AxiosRequestConfig = {}) => {
  const { signal } = config;

  const response = await httpClient.get<LocationFeature[]>(
    apiRoutes.service.locationFeatures,
    {
      signal,
    }
  );

  return response.data;
};

export const useGetLocationFeatures = (
  opts?: Omit<UseQueryOptions<LocationFeature[], DefaultQueryError>, 'queryKey'>
) =>
  useQuery<LocationFeature[], DefaultQueryError>({
    queryKey: [apiRoutes.service.locationFeatures],
    queryFn: ({ signal }) => locationFeaturesFn({ signal }),
    ...opts,
  });
